import { getCapitalActivitySummaryRetrieveQueryKey } from "gen/endpoints/capital-activity/capital-activity";
import {
  getCapitalCallReallocationDraftDataRetrieveQueryKey,
  useCapitalCallReallocationDraftDataRetrieveSuspense,
} from "gen/endpoints/capital-call-reallocation-draft-data/capital-call-reallocation-draft-data";
import { useFundFamilyEventDelete } from "gen/endpoints/fund-family-event/fund-family-event";
import { FundFamilyEventStateMachineFieldsEnum } from "gen/model/fundFamilyEventStateMachineFieldsEnum";
import { useCallback } from "react";
import { useInvalidateQueryKeys } from "shared/utils/QueryUtils";

export const useDraftReallocationState = ({
  fundFamilyId,
  fundFamilyEventId,
}: {
  fundFamilyId: string;
  fundFamilyEventId: string;
}) => {
  const { data: reallocationDraftData } =
    useCapitalCallReallocationDraftDataRetrieveSuspense(
      fundFamilyId,
      fundFamilyEventId,
    );

  const existingReallocationEventId =
    reallocationDraftData.reallocation_fund_family_event?.id ?? "";

  const hasDraftAllocation =
    existingReallocationEventId &&
    reallocationDraftData.reallocation_fund_family_event?.state ===
      FundFamilyEventStateMachineFieldsEnum.draft;

  const invalidateQueries = useInvalidateQueryKeys();
  const { mutateAsync: _deleteReallocationEvent } = useFundFamilyEventDelete({
    mutation: {
      onSuccess: async () => {
        await invalidateQueries(
          getCapitalCallReallocationDraftDataRetrieveQueryKey(
            fundFamilyId,
            fundFamilyEventId,
          ),
          getCapitalActivitySummaryRetrieveQueryKey(fundFamilyId),
        );
      },
    },
  });

  const deleteReallocationEvent = useCallback(async () => {
    if (existingReallocationEventId) {
      await _deleteReallocationEvent({
        fundFamilyId,
        fundFamilyEventId: existingReallocationEventId,
      });
    }
  }, [_deleteReallocationEvent, existingReallocationEventId, fundFamilyId]);

  return {
    hasDraftAllocation,
    existingReallocationEventId,
    deleteReallocationEvent,
  };
};
